import type { SVGProps } from 'react';

export function CheckboxUnchecked(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0.5 16 16" fill="none" {...props}>
      <mask id="path-1-inside-1_2868_158226" fill="white">
        <path d="M0 1.5C0 0.947715 0.447715 0.5 1 0.5H15C15.5523 0.5 16 0.947715 16 1.5V15.5C16 16.0523 15.5523 16.5 15 16.5H1C0.447715 16.5 0 16.0523 0 15.5V1.5Z" />
      </mask>
      <path
        d="M0 1.5C0 0.947715 0.447715 0.5 1 0.5H15C15.5523 0.5 16 0.947715 16 1.5V15.5C16 16.0523 15.5523 16.5 15 16.5H1C0.447715 16.5 0 16.0523 0 15.5V1.5Z"
        fill="white"
      />
      <path
        d="M1 1.5H15V-0.5H1V1.5ZM15 1.5V15.5H17V1.5H15ZM15 15.5H1V17.5H15V15.5ZM1 15.5V1.5H-1V15.5H1ZM1 15.5H-1C-1 16.6046 -0.104569 17.5 1 17.5V15.5ZM15 15.5V17.5C16.1046 17.5 17 16.6046 17 15.5H15ZM15 1.5H17C17 0.395431 16.1046 -0.5 15 -0.5V1.5ZM1 -0.5C-0.104569 -0.5 -1 0.395431 -1 1.5H1V-0.5Z"
        fill="currentColor"
        mask="url(#path-1-inside-1_2868_158226)"
      />
    </svg>
  );
}

export function CheckboxIndeterminate(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0.5 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M0 1.5C0 0.947715 0.447715 0.5 1 0.5H15C15.5523 0.5 16 0.947715 16 1.5V15.5C16 16.0523 15.5523 16.5 15 16.5H1C0.447715 16.5 0 16.0523 0 15.5V1.5Z"
        fill="currentColor"
      />
      <path fillRule="evenodd" clipRule="evenodd" d="M4 7.75H12V9.25H4V7.75Z" fill="#F9FAFB" />
    </svg>
  );
}

export function CheckboxChecked(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0.5 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M0 1.5C0 0.947715 0.447715 0.5 1 0.5H15C15.5523 0.5 16 0.947715 16 1.5V15.5C16 16.0523 15.5523 16.5 15 16.5H1C0.447715 16.5 0 16.0523 0 15.5V1.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5152 6.04509L6.66106 12.5249L2.49304 8.70221L3.50691 7.59674L6.64556 10.4753L12.4847 4.95508L13.5152 6.04509Z"
        fill="#F9FAFB"
      />
    </svg>
  );
}
